import {IconButton as MUIIconButton} from '@mui/material'

export const IconButton = MUIIconButton
